export const locale = {
    lang: 'en',
    data: {
        LANDING_SEARCH: {
            TITLES: {
                ANY: 'Any',
                BUY: 'Buy',
                RENT: 'Rent',
                PRICE: 'Price',
                BEDS: 'Beds',
                SEARCH: 'Search'
            },
            FILTERS: {
                ANY: 'Any',
                UP_TO: 'Up to',
                BED: {
                    STUDIO: 'Studio'
                }
            }
        }
    }
};